"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// These act as global styles
var styles = {
  global: {
    html: {
      overflowX: 'hidden'
    },
    body: {
      height: '100vh',
      fontSize: 'md',
      color: 'semantics.default',
      lineHeight: 'base',
      fontFamily: 'body',
      fontWeight: 'normal',
      overflowX: 'hidden'
      /* Prevent modals from shifting content when opened/closed */
      // overflow: 'auto !important',
      // paddingRight: '0 !important',

      /**/

    },
    '#root': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    main: {
      // main expands if page doesn't have enough content
      flex: 1
    },
    '*:focus': {
      outline: 0
    },
    '*:focus-visible': {
      boxShadow: '0 0 0 2px rgba(66, 153, 225, 0.5)'
    }
  }
};
var _default = styles;
exports.default = _default;

//# sourceMappingURL=styles.js.map